module.exports = __webpack_public_path__ + "static/img/logo_multi@2x.2707dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/financialCompetition/logo_multi@2x.png
// module id = +Ywf
// module chunks = 86